// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import Modal from '../../../components/Modals/Shared/Modal';
import ModalHeader from '../../../components/Modals/Shared/ModalHeader';
import SignUpEmail from './SignUpEmail';
import { signupLadySmallUrl } from '../../../utils/urls';
import styles from './SignUpModal.module.scss';

const headerText = <FormattedMessage id="signUpModal.header" />;

type Props = {
    bidderExists: boolean,
    cancelSignUp: Function,
    error: string,
    isMobile: boolean,
    isTablet: boolean,
    openLoginModal: Function,
    setEmail: Function,
    show: boolean,
    submitCreateAccount: Function,
    submitted: boolean,
    whiteLabel: boolean,
};

export default class SignUpModal extends Component<Props> {
    static defaultProps = {
        error: '',
        show: false,
        submitted: false,
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            bidderExists,
            cancelSignUp,
            error,
            isMobile,
            isTablet,
            openLoginModal,
            setEmail,
            show,
            submitCreateAccount,
            submitted,
            whiteLabel,
        } = this.props;

        const footerContent = (
            <FormattedMessage
                id="signUpModal.footer"
                values={{
                    link: (
                        <Link key="link" onClick={openLoginModal}>
                            <FormattedMessage id="signUpModal.footerLink" />
                        </Link>
                    ),
                }}
            />
        );

        const modalHeader = <ModalHeader onHide={cancelSignUp} content={headerText} hideLogo={whiteLabel} />;
        const modalLeftImage = isMobile && !isTablet ? null : <ImageWithFallback src={signupLadySmallUrl} />;
        const modalBody = (
            <div>
                <SignUpEmail
                    bidderExists={bidderExists}
                    error={error}
                    setEmail={setEmail}
                    submitCreateAccount={submitCreateAccount}
                    submitted={submitted}
                />
            </div>
        );
        const modalFooter = <div>{footerContent}</div>;

        return (
            <Modal
                body={modalBody}
                contentLabel="SignUpModal"
                footer={modalFooter}
                footerClassName={styles.footer}
                header={modalHeader}
                leftImage={modalLeftImage}
                show={show}
            />
        );
    }
}
